export const LogoutIcon: React.FC<React.SVGAttributes<{}>> = props => (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M12 5.10563L11.06 6.04563L12.78 7.7723H6V9.10563H12.78L11.06 10.8256L12 11.7723L15.3333 8.43896L12 5.10563ZM3.33333 3.7723H8.66667V2.43896H3.33333C2.6 2.43896 2 3.03896 2 3.7723V13.1056C2 13.839 2.6 14.439 3.33333 14.439H8.66667V13.1056H3.33333V3.7723Z"
            fill="white"
        />
    </svg>
);
